export class Utilities { 

  static makeDate(input: any): Date {
    return new Date(new Date(input).setHours(0, 0, 0, 0))
  }
  static getDateInInputStringFormat(date: Date): string {
    let result    = ""
    const mm      = date.getMonth() + 1
    const dd      = date.getDate()
    result        = [date.getFullYear(),
                      (mm > 9 ? '' : '0') + mm,
                      (dd > 9 ? '' : '0') + dd
                    ].join('-')
    return result
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/helpers/utilities.ts